import { mediaUrl } from "./constants";

const MovieCard = ({ info }) => {
  const { id, backdrop_path, original_title } = info;

  return (
    <div className="rounded-lg overflow-hidden drop-shadow-md max-w-[400px] border-[1px] border-gray-400">
      <img key={id} src={mediaUrl + backdrop_path} />
      <div className="bg-w font-sans py-4 text-center font-semibold font-xl">
        {original_title}
      </div>
    </div>
  );
};

export const WithNewLabel = (MovieCard) => {
  return (props) => {
    return (
      <div>
        <label className="absolute z-10 bg-blue-600 text-white rounded-lg py-2 px-4">
          New 🌱
        </label>
        <MovieCard {...props} />
      </div>
    );
  };
};
export default MovieCard;
